import { SpotlightAction, SpotlightProvider } from "@mantine/spotlight";
import { useAppSelector } from "Hooks/redux-hooks";
import { Suspense, useState } from "react";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { Search } from "tabler-icons-react";
import useMyPrivilege from "../Hooks/Privilege/useMyPrivilege";
import Login from "./Auth/Login";
import ResetPassword from "./Auth/ResetPassword";
import Body from "./Body/Body";
import Loader from "./Common/Loader/Loader";
import NavbarUI from "./Navbar/Navbar";
import Sidebar from "./Sidebar/Sidebar";
import { sidebarRoutes } from "./sidebarRoutes";
import useBank from "Hooks/Bank/useBank";
import { ErrorBoundary } from "react-error-boundary";
import GlobalError from "./Common/ui/Error/GlobalError";

const Main = () => {
  const isLoading = useAppSelector((state) => state.loading.loading);
  const isLoggedIn = useAppSelector((state) => state.login.login);

  return (
    <div className="col-12 d-flex">
      <ErrorBoundary fallback={<GlobalError />}>
        <Loader opened={isLoading} />
        {isLoggedIn ? (
          <Childrens />
        ) : (
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        )}
      </ErrorBoundary>
    </div>
  );
};

export default Main;

const Childrens = () => {
  const navigate = useNavigate();

  const [actions, setActions] = useState<SpotlightAction[]>([]);

  useBank();

  useMyPrivilege((data) => {
    var myAllRoutes: SpotlightAction[] = [];
    var tempList = data.data.privileges.map((e) => e.privilege_key);
    sidebarRoutes
      .filter((e) => {
        for (const prev of e?.permission) {
          if (tempList.includes(`manage_${prev}`)) {
            return true;
          }
        }
        return false;
      })
      .forEach((e) => {
        myAllRoutes.push({
          title: e.title,
          description: e.desc,
          onTrigger: () => {
            if (e.to) navigate(e?.to ?? e?.children?.[0].to);
          },
          icon: (
            <img alt="" src={e.icon} className="sidebar-leading-icon my-auto" />
          ),
        });
        if (e.children) {
          e.children.forEach((child) => {
            myAllRoutes.push({
              title: child.title,
              description: child.desc,
              onTrigger: () => {
                if (child.to) navigate(child?.to ?? child?.children?.[0].to);
              },
              icon: (
                <img
                  alt=""
                  src={child.icon}
                  className="sidebar-leading-icon my-auto"
                />
              ),
            });
          });
        }
      });
    setActions([...myAllRoutes]);
  });

  return (
    <SpotlightProvider
      actions={actions}
      searchIcon={<Search size={18} />}
      searchPlaceholder="Search..."
      shortcut={["mod + P"]}
      limit={7}
      nothingFoundMessage="Nothing found..."
    >
      <Suspense fallback={<></>}>
        <Sidebar />
        <div className="main-content">
          <NavbarUI />
          <Body />
        </div>
      </Suspense>
    </SpotlightProvider>
  );
};
